<template>
  <svg xmlns="http://www.w3.org/2000/svg" display="none">

    <!-- Clock Icon -->
    <symbol id="icon-clock" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </symbol>

    <!-- Price Icon -->
    <symbol id="icon-price" viewBox="0 0 649 512">
      <path d="M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"></path>
    </symbol>

    <!-- Location Icon -->
    <symbol id="icon-location" viewBox="0 0 24 24">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
    </symbol>

    <!-- Person Icon -->
    <symbol id="icon-person" viewBox="0 0 24 24">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </symbol>

    <!-- Info Icon -->
    <symbol id="icon-info" viewBox="0 0 24 24">
      <path d="M12.939 6.053c-.121-.093-.26-.159-.422-.196-.159-.037-.331-.056-.512-.056-.182 0-.354.019-.517.056-.163.037-.305.103-.426.196-.12.093-.215.217-.285.369-.07.153-.104.344-.104.574 0 .225.035.414.104.569.07.155.164.281.285.374.121.093.263.161.426.2.163.04.335.06.517.06.181 0 .353-.02.512-.06.162-.039.301-.108.422-.2.12-.093.217-.218.289-.374.072-.154.108-.344.108-.569 0-.23-.036-.422-.108-.574C13.156 6.27 13.059 6.146 12.939 6.053zM10.777 9.159H13.224V18.126H10.777z"/><path fill="none" d="M0 0H24V24H0z"/>
      <path d="M12,0C5.373,0,0,5.373,0,12c0,6.627,5.373,12,12,12s12-5.373,12-12C24,5.373,18.627,0,12,0z M12,22 C6.477,22,2,17.523,2,12C2,6.477,6.477,2,12,2s10,4.477,10,10C22,17.523,17.523,22,12,22z"/>
        <circle cx="12" cy="10" r="3"></circle>
    </symbol>

    <!-- PDF Icon -->
    <symbol id="icon-pdf" viewBox="0 0 512 512">
      <g>
        <path d="M444.875,109.792L338.208,3.125c-2-2-4.708-3.125-7.542-3.125h-224C83.135,0,64,19.135,64,42.667v426.667
				C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333v-352
				C448,114.5,446.875,111.792,444.875,109.792z M341.333,36.417l70.25,70.25h-48.917c-11.76,0-21.333-9.573-21.333-21.333V36.417z
				 M426.667,469.333c0,11.76-9.573,21.333-21.333,21.333H106.667c-11.76,0-21.333-9.573-21.333-21.333V42.667
				c0-11.76,9.573-21.333,21.333-21.333H320v64C320,108.865,339.135,128,362.667,128h64V469.333z"/>
        <path d="M310.385,313.135c-9.875-7.771-19.26-15.76-25.51-22.01c-8.125-8.125-15.365-16-21.656-23.5
				c9.813-30.323,14.115-45.958,14.115-54.292c0-35.406-12.792-42.667-32-42.667c-14.594,0-32,7.583-32,43.688
				c0,15.917,8.719,35.24,26,57.698c-4.229,12.906-9.198,27.792-14.781,44.573c-2.688,8.052-5.604,15.51-8.688,22.406
				c-2.51,1.115-4.948,2.25-7.302,3.427c-8.479,4.24-16.531,8.052-24,11.594C150.5,370.177,128,380.844,128,401.906
				c0,15.292,16.615,24.76,32,24.76c19.833,0,49.781-26.49,71.656-71.115c22.708-8.958,50.938-15.594,73.219-19.75
				c17.854,13.729,37.573,26.865,47.125,26.865c26.448,0,32-15.292,32-28.115c0-25.219-28.813-25.219-42.667-25.219
				C337.031,309.333,325.49,310.604,310.385,313.135z M160,405.333c-6.094,0-10.219-2.875-10.667-3.427
				c0-7.563,22.552-18.25,44.365-28.583c1.385-0.656,2.792-1.313,4.219-1.99C181.896,394.563,166.052,405.333,160,405.333z
				 M234.667,214.354c0-22.354,6.938-22.354,10.667-22.354c7.542,0,10.667,0,10.667,21.333c0,4.5-3,15.75-8.49,33.313
				C239.135,233.75,234.667,222.698,234.667,214.354z M242.844,329c0.667-1.854,1.313-3.729,1.938-5.625
				c3.958-11.875,7.521-22.542,10.698-32.146c4.427,4.875,9.198,9.865,14.313,14.979c2,2,6.958,6.5,13.563,12.135
				C270.208,321.208,256.219,324.76,242.844,329z M362.667,334.552c0,4.792,0,6.781-9.896,6.844
				c-2.906-0.625-9.625-4.583-17.917-10.229c3.01-0.333,5.229-0.5,6.479-0.5C357.094,330.667,361.563,332.208,362.667,334.552z"/>
      </g>
    </symbol>

    <!-- Arrow Down Icon -->
    <symbol id="icon-down-arrow" viewBox="0 0 20 20">
      <path fill="none" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4" />
    </symbol>

    <!-- Icon vehicle -->
    <symbol id="icon-down-arrow" viewBox="0 0 20 20">
      <path fill="none" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 8l4 4 4-4" />
    </symbol>

    <symbol xmlns="http://www.w3.org/2000/svg" id="icon-vehicle" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
      <g><path fill="black" d="M469,215h-9.7L426.6,51.2H85.4L52.6,215H43c-22.6,0-41,18.4-41,41v155.7h49.2v32.8c0,9,7.3,16.4,16.4,16.4h49.2   c9,0,16.4-7.3,16.4-16.4v-32.8h245.8v32.8c0,9,7.3,16.4,16.4,16.4h49.2c9,0,16.4-7.3,16.4-16.4v-32.8H510V256   C510,233.4,491.6,215,469,215z M98.8,67.5h314.3L442.7,215H69.3L98.8,67.5z M67.5,444.5v-32.8h49.2l0,32.8H67.5z M395.3,444.5   v-32.8h49.2l0,32.8H395.3z M493.6,395.3H18.4V256c0-13.6,11-24.6,24.6-24.6H469c13.6,0,24.6,11,24.6,24.6V395.3z"></path><path fill="black" d="M116.7,264.2c-27.1,0-49.2,22.1-49.2,49.2c0,27.1,22.1,49.2,49.2,49.2s49.2-22.1,49.2-49.2   C165.9,286.2,143.8,264.2,116.7,264.2z M116.7,346.1c-18.1,0-32.8-14.7-32.8-32.8c0-18.1,14.7-32.8,32.8-32.8s32.8,14.7,32.8,32.8   C149.5,331.4,134.8,346.1,116.7,346.1z"></path><path fill="black" d="M395.3,264.2c-27.1,0-49.2,22.1-49.2,49.2c0,27.1,22.1,49.2,49.2,49.2c27.1,0,49.2-22.1,49.2-49.2   C444.5,286.2,422.4,264.2,395.3,264.2z M395.3,346.1c-18.1,0-32.8-14.7-32.8-32.8c0-18.1,14.7-32.8,32.8-32.8s32.8,14.7,32.8,32.8   C428.1,331.4,413.4,346.1,395.3,346.1z"></path><rect fill="black" x="198.6" y="305.2" width="114.7" height="16.4"></rect></g>
    </symbol>
  </svg>
</template>

<script>
  export default {
    name: "AppSvgContainer"
  }
</script>
